module.exports = __webpack_public_path__ + "img/timeline-05.0ddb5eca.svg";